import axios from '@/axios.js'
import moment from 'moment'
import { format } from 'core-js/fn/date';
const eventsApiUrl = 'https://management.evolugy.com/v1/events';
const managementApiUrl = 'https://management.evolugy.com/v1/';
const usersApiUrl = 'https://users.evolugy.com/v1/';
const factUrl = 'https://fel.maypos.store/dev/factura.php';
const anulUrl = 'https://fel.maypos.store/dev/anulacion.php?7506309898889&750630989888942277392'
const nitUrl = 'https://fel.maypos.store/dev/nit.php/validar/'
const cloudFunctionUrl = 'https://us-central1-evolugy2020.cloudfunctions.net/getToken';
const notificationsUrl = 'https://notifications.evolugy.com/v1/notifications';
const clinicsUrl = 'https://evolugy-management.herokuapp.com/v1/clinics';
const dateStringOptions = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
const timeStringOptions = { hour: 'numeric', minute: 'numeric', hour12: true };

// HTML TEMPLATES
// paciente - cuando se agrega un nuevo paciente DONE
import { newPatientHTML } from './HTML-templates/newPatient-patient';
import { newPatientWA } from './WA-templates/newPatient-patient';
// paciente - cuando se confirma la confirmación de una consulta | confirma que confirmaste DONEish
import { confirmWA } from './WA-templates/confirmation';
import { confirmHTML } from './HTML-templates/confirmation';
// paciente - cuando se re-confirma la confirmación de una consulta | confirma que re-confirmaste 
import { reConfirmWA } from './WA-templates/reconfirmation';
import { reConfirmHTML } from './HTML-templates/reconfirmation';
// paciente - "confirma"/notifica que se creo una consulta DONE
import { confirmConWA } from './WA-templates/confirmConsultation.js';
import { confirmConHTML } from './HTML-templates/confirmConsultation';
// paciente - "confirma"/notifica que se creo una consulta a un paciente nuevo. DONE
import { consultationPatientWA } from './WA-templates/consultationNewPatient';
import { consultationPatientHTML } from './HTML-templates/consultationNewPatient';
// paciente - recordatorio 24hrs antes * pendiente
import { reminderWA } from './WA-templates/consultationReminder';
import { reminderHTML } from './HTML-templates/consultationReminder';
// paciente - genera un correo con un link para solicitar una consulta DONE
import { consultationReqWA } from './WA-templates/consultationRequest';
import { consultationReqHTML } from './HTML-templates/consultationRequest';
// doctor - notifica al doctor que se creo una nueva consulta proveniente del paciente PUBLICA
import { consultationScheWA } from './WA-templates/consultationScheduled';
import { consultationScheHTML } from './HTML-templates/consultationScheduled';
// paciente - resumen de una consulta *cuando se marca como terminada
import { summaryWA } from './WA-templates/summary.js'; //PENDIENTE
import { summaryHTML } from './HTML-templates/consultationSummary';
// secretaria - invitación a una secretaria nueva * secretaria nueva
import { newSecretaryHTML } from './HTML-templates/newSecretary';
// secretaria - confirmación que fue agregada a un doctor * secretaria existente
import { existingSecretaryWA } from './WA-templates/existingSecretary'
import { existingSecretaryHTML } from './HTML-templates/existingSecretary';
// paciente - le dice al paciente que se anulo una consulta
import { annulationWA } from './WA-templates/consultationAnnulation';
import { annulationHTML } from './HTML-templates/consultationAnnulation';
// paciente - le avisao que un consulta fue editada
import { notifyEditWA_P } from './WA-templates/notifyEditConsultationP'
import { notifyEditHTML_P } from './HTML-templates/notifyEditConsultationP';
// doctor - la avisa que uan consulta fue editada
import { notifyEditHTML_DWA } from './WA-templates/notifyEditConsultationD'
import { notifyEditHTML_D } from './HTML-templates/notifyEditConsultationD';

import { prescriptionWA } from './WA-templates/prescription';

import { reject, resolve } from 'core-js/fn/promise';


// data conversion functions

// crear template -> crear funciones que disparen la notificacion con template  -> llamar a funciones desde las vistas. 

const areaCodes = ["501", "502", "503", "504", "505", "506", "507"];

function verifyNumber(number) {

    var patient_phone = areaCodes.includes(number.substring(0, 2)) ? number : '502' + number;
    return patient_phone
}

String.prototype.toUnicode = function() {
    var result = "";
    for (var i = 0; i < this.length; i++) {
        // Assumption: all characters are < 0xffff
        result += "\\u" + ("000" + this[i].charCodeAt(0).toString(16)).substr(-4);
    }
    return result;
};

function getDateTimeZone(date) {
    var date = new Date(date);
    var dateStr =
        date.getFullYear() + "-" +
        ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
        ("00" + date.getDate()).slice(-2) + " " +
        ("00" + date.getHours()).slice(-2) + ":" +
        ("00" + date.getMinutes()).slice(-2) + ":" +
        ("00" + date.getSeconds()).slice(-2) + " GMT-0600";

    return dateStr;
}

const isToday = (someDate) => {
    const today = new Date()
    return someDate.getDate() == today.getDate() &&
        someDate.getMonth() == today.getMonth() &&
        someDate.getFullYear() == today.getFullYear()
}

function createTimeTable(min = '08:00', max = '16:00') {
    const hours = [];
    const startTime = moment(min, 'HH:mm').hour();
    const endTime = moment(max, 'HH:mm').hour();
    for (let hour = startTime; hour < endTime; hour++) {
        hours.push(moment({ hour }).format('HH:mm'));
        // hours.push(
        //   moment({
        //     hour,
        //     minute: 0
        //   }).format('HH:mm')
        // );
    }
    return hours;
}

function getValidHours(startTime, endTime, date) {
    if (startTime && endTime) {
        const currentDate = moment().format('MM-DD-YYYY');
        if (date === currentDate) {
            const currentHour = parseInt(moment().format('H'));
            const startTimeHour = parseInt(startTime.substr(0, 2));
            const endTimeHour = parseInt(endTime.substr(0, 2));
            const finalStartTime = startTimeHour <= currentHour ? currentHour + 1 : startTimeHour;
            if (finalStartTime < endTimeHour) {
                const zeroPad = (num, places) => String(num).padStart(places, '0');
                return { startTime: `${zeroPad(finalStartTime,2)}:00`, endTime: endTime }
            }
            return { startTime: null, endTime: null }
        }
    }
    return { startTime, endTime }
}

const globalTimeTable = createTimeTable();

const actions = {
    // SECRETARY
    updateDoctorID({ commit }, id) {
        return commit('SET_ACTIVE_DOCTOR_ID', id)
    },
    // 
    // /////////////////////////////////////////////
    // COMPONENTS
    // /////////////////////////////////////////////

    // Vertical NavMenu
    updateVerticalNavMenuWidth({ commit }, width) {
        commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
    },

    // VxAutoSuggest
    updateStarredPage({ commit }, payload) {
        commit('UPDATE_STARRED_PAGE', payload)
    },

    // The Navbar
    arrangeStarredPagesLimited({ commit }, list) {
        commit('ARRANGE_STARRED_PAGES_LIMITED', list)
    },
    arrangeStarredPagesMore({ commit }, list) {
        commit('ARRANGE_STARRED_PAGES_MORE', list)
    },

    // /////////////////////////////////////////////
    // UI
    // /////////////////////////////////////////////

    toggleContentOverlay({ commit }) {
        commit('TOGGLE_CONTENT_OVERLAY')
    },
    updateTheme({ commit }, val) {
        commit('UPDATE_THEME', val)
    },

    // /////////////////////////////////////////////
    // User/Account
    // /////////////////////////////////////////////
    updateUserInfo({ commit }, payload) {
        commit('UPDATE_USER_INFO', payload)
    },
    updateUserRole({ dispatch }, payload) {
        // Change client side
        payload.aclChangeRole(payload.userRole)

        // Make API call to server for changing role

        // Change userInfo in localStorage and store
        dispatch('updateUserInfo', { userRole: payload.userRole })
    },
    wakeUpCloud({ commit, rootState }) {
        console.log('wakingUp')
        return new Promise((resolve, reject) => {

            axios.post(cloudFunctionUrl, {})
                .then((response) => {
                    //console.log(response);
                    let adminToken = response.data.user.stsTokenManager.accessToken;

                })
                .catch((error) => { reject(error) });
            // --

        });
    },
    // USERS - PATIENTS
    // ----------------
    registerPatientPublic({ dispatch }, payload) {

        return new Promise((resolve, reject) => {
            axios.post(cloudFunctionUrl, {})
                .then((response) => {
                    // console.log(response);
                    var adminToken = response.data.user.stsTokenManager.accessToken;

                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + adminToken
                    }

                    axios.post(usersApiUrl, payload, {
                        headers: headers
                    }).then((response) => {
                        // console.log(response);
                        dispatch('linkUserPublic', {
                            doctor_id: payload.meta.doctor_id,
                            email: response.data.data.user.email
                        }).then(() => resolve(response), (error) => reject(error));
                    }, (error) => {

                        reject(error)

                    });
                })
                .catch((error) => { reject(error) });
        })
    },
    // ------------------------
    // ----- Notify Actions----
    // ------------------------
    notifyReConfirmationSuccessPublic({ dispatch, rootState }, event) {
        //console.log('CONFIRM SUCCESS');
        //console.log('payload', payload)
        return new Promise((resolve, reject) => {
            dispatch('getConsultationByIdPublic', event.id).then(response => {
                var notifPayload = JSON.stringify({
                    "type": "email",
                    "title": "Re-Confirmación de consulta #" + response.data.data.event.id + " éxitosa!",
                    "message": reConfirmHTML({
                        clinic_name: response.data.data.event.clinic.title,
                        clinic_address: response.data.data.event.clinic.address,
                        clinic_address_2: response.data.data.event.clinic.address_2,
                        clinic_city: response.data.data.event.clinic.city ? response.data.data.event.clinic.city : '',
                        clinic_country: response.data.data.event.clinic.country ? response.data.data.event.clinic.country : '',
                        clinic_phone: response.data.data.event.clinic.phone[0] ? response.data.data.event.clinic.phone[0] : '',
                        doctor_name: response.data.data.event.doctor.first_name + ' ' + response.data.data.event.doctor.last_name,
                        patient_id: response.data.data.event.patient.id,
                        patient_name: response.data.data.event.patient.first_name + " " + response.data.data.event.patient.last_name,
                        patient_first_name: response.data.data.event.patient.first_name,
                        doctor_id: response.data.data.event.doctor.id,
                        consultation_id: response.data.data.event.id,
                        date_time: new Date(response.data.data.event.date).toLocaleDateString('es-ES', dateStringOptions) + ' a las ' +
                            new Date(response.data.data.event.date).toLocaleTimeString('en-EN', timeStringOptions),
                    }),
                    "target": {
                        "email": { "$like": "%" + response.data.data.event.patient.email + "%" }
                    }
                });
                // whatsapp payload
                var patient_phone = response.data.data.event.patient.phone[0];
                var notifPayloadWA = JSON.stringify({
                    "type": "whatsapp",
                    "title": ("Re-Confirmación de consulta No." + response.data.data.event.id + " éxitosa!").toUnicode(),
                    "message": reConfirmWA({
                        clinic_name: response.data.data.event.clinic.title,
                        clinic_address: response.data.data.event.clinic.address,
                        clinic_address_2: response.data.data.event.clinic.address_2,
                        clinic_city: response.data.data.event.clinic.city ? response.data.data.event.clinic.city : '',
                        clinic_country: response.data.data.event.clinic.country ? response.data.data.event.clinic.country : '',
                        clinic_phone: response.data.data.event.clinic.phone[0] ? response.data.data.event.clinic.phone[0] : '',
                        doctor_name: response.data.data.event.doctor.first_name + ' ' + response.data.data.event.doctor.last_name,
                        patient_id: response.data.data.event.patient.id,
                        patient_name: response.data.data.event.patient.first_name + " " + response.data.data.event.patient.last_name,
                        patient_first_name: response.data.data.event.patient.first_name,
                        doctor_id: response.data.data.event.doctor.id,
                        consultation_id: response.data.data.event.id,
                        date_time: new Date(response.data.data.event.date).toLocaleDateString('es-ES', dateStringOptions) + ' a las ' +
                            new Date(response.data.data.event.date).toLocaleTimeString('en-EN', timeStringOptions),
                    }).toUnicode(),
                    "url": ``,
                    "meta": {
                        "to": patient_phone
                    }
                });

                dispatch('sendNotificationPublic', notifPayload).then((response2) => {
                    dispatch('sendNotificationPublic', notifPayloadWA).then((response3) => {
                        resolve(response3);
                    }).catch((error) => { reject(error) });
                }).catch((error) => { reject(error) });


            });
        })

    },
    notifyReConfirmationSuccess({ dispatch, rootState }, event) {
        dispatch('getConsultationById', event.id).then(response => {

            return new Promise((resolve, reject) => {
                // email payload
                var notifPayload = JSON.stringify({
                    "type": "email",
                    "title": "Re-Confirmación de consulta #" + response.data.data.event.id + " éxitosa!",
                    "message": reConfirmHTML({
                        clinic_name: response.data.data.event.clinic.title,
                        clinic_address: response.data.data.event.clinic.address,
                        clinic_address_2: response.data.data.event.clinic.address_2,
                        clinic_city: response.data.data.event.clinic.city ? response.data.data.event.clinic.city : '',
                        clinic_country: response.data.data.event.clinic.country ? response.data.data.event.clinic.country : '',
                        clinic_phone: response.data.data.event.clinic.phone[0] ? response.data.data.event.clinic.phone[0] : '',
                        doctor_name: response.data.data.event.doctor.first_name + ' ' + response.data.data.event.doctor.last_name,
                        patient_id: response.data.data.event.patient.id,
                        patient_name: response.data.data.event.patient.first_name + " " + response.data.data.event.patient.last_name,
                        patient_first_name: response.data.data.event.patient.first_name,
                        doctor_id: response.data.data.event.doctor.id,
                        consultation_id: response.data.data.event.id,
                        date_time: new Date(response.data.data.event.date).toLocaleDateString('es-ES', dateStringOptions) + ' a las ' +
                            new Date(response.data.data.event.date).toLocaleTimeString('en-EN', timeStringOptions),
                    }),
                    "target": {
                        "email": { "$like": "%" + response.data.data.event.patient.email + "%" }
                    }
                });
                // whatsapp payload
                var patient_phone = response.data.data.event.patient.phone[0];
                var notifPayloadWA = JSON.stringify({
                    "type": "whatsapp",
                    "title": ("Re-Confirmación de consulta No." + response.data.data.event.id + " éxitosa!").toUnicode(),
                    "message": reConfirmWA({
                        clinic_name: response.data.data.event.clinic.title,
                        clinic_address: response.data.data.event.clinic.address,
                        clinic_address_2: response.data.data.event.clinic.address_2,
                        clinic_city: response.data.data.event.clinic.city ? response.data.data.event.clinic.city : '',
                        clinic_country: response.data.data.event.clinic.country ? response.data.data.event.clinic.country : '',
                        clinic_phone: response.data.data.event.clinic.phone[0] ? response.data.data.event.clinic.phone[0] : '',
                        doctor_name: response.data.data.event.doctor.first_name + ' ' + response.data.data.event.doctor.last_name,
                        //patient_id: response.data.data.event.patient.id,
                        patient_name: response.data.data.event.patient.first_name + " " + response.data.data.event.patient.last_name,
                        patient_first_name: response.data.data.event.patient.first_name,
                        doctor_id: response.data.data.event.doctor.id,
                        consultation_id: response.data.data.event.id,
                        date_time: new Date(response.data.data.event.date).toLocaleDateString('es-ES', dateStringOptions) + ' a las ' +
                            new Date(response.data.data.event.date).toLocaleTimeString('en-EN', timeStringOptions),
                    }).toUnicode(),
                    "url": ``,
                    "meta": {
                        "to": patient_phone
                    }
                });

                dispatch('sendNotification', notifPayload).then((response2) => {
                    dispatch('sendNotification', notifPayloadWA).then((response3) => {
                        resolve(response3);
                    }).catch((error) => { reject(error) });
                }).catch((error) => { reject(error) });
            });
        });
    },
    sendPrescription({ dispatch, rootState }, event) {
        dispatch('getConsultationById', event).then(response => {

            return new Promise((resolve, reject) => {
                // whatsapp payload
                var patient_phone = response.data.data.event.patient.phone[0];
                var notifPayloadWA = JSON.stringify({
                    "type": "whatsapp",
                    "title": ("Prescripción Médica de la consulta " + response.data.data.event.id).toUnicode(),
                    "message": prescriptionWA({
                        clinic_name: response.data.data.event.clinic.title,
                        clinic_address: response.data.data.event.clinic.address,
                        clinic_address_2: response.data.data.event.clinic.address_2,
                        clinic_city: response.data.data.event.clinic.city ? response.data.data.event.clinic.city : '',
                        clinic_country: response.data.data.event.clinic.country ? response.data.data.event.clinic.country : '',
                        clinic_phone: response.data.data.event.clinic.phone[0] ? response.data.data.event.clinic.phone[0] : '',
                        doctor_name: response.data.data.event.doctor.first_name + ' ' + response.data.data.event.doctor.last_name,
                        //patient_id: response.data.data.event.patient.id,
                        patient_name: response.data.data.event.patient.first_name + " " + response.data.data.event.patient.last_name,
                        patient_first_name: response.data.data.event.patient.first_name,
                        doctor_id: response.data.data.event.doctor.id,
                        consultation_id: response.data.data.event.id,
                        date_time: new Date(response.data.data.event.date).toLocaleDateString('es-ES', dateStringOptions) + ' a las ' +
                            new Date(response.data.data.event.date).toLocaleTimeString('en-EN', timeStringOptions),
                    }).toUnicode(),
                    "url": `https://app.evolugy.com/links/consultation-review/${response.data.data.event.id}`,
                    "meta": {
                        "to": patient_phone
                    }
                });

                    dispatch('sendNotification', notifPayloadWA).then((response3) => {
                        resolve(response3);
                }).catch((error) => { reject(error) });
            });
        });
    },
    sendPDF({dispatch, rootState}, payload) {
        return new Promise((resolve, reject) => {
            console.log(payload)
            var pdfPayload = JSON.stringify({
                "type": "whatsapp",
                "title": "Upload",
                "message": "FILE TO UPLOAD",
                "url": payload.url,
                "meta": {
                    "to": payload.phone
                }
            })
            dispatch('sendNotificationPublic', pdfPayload).then((response) => {
                resolve(response)
            }).catch((err) => {
                reject(err)
                console.log(err)
            })
        })
    },
    notifyConfirmSuccess({ dispatch, rootState }, payload) {
        //console.log('CONFIRM SUCCESS');
        //console.log('payload', payload)
        return new Promise((resolve, reject) => {
            dispatch('getConsultationByIdPublic', payload.data.data.event.id).then(response2 => {
                // notificacion
                var notifPayload = JSON.stringify({
                    "type": "email",
                    "title": "Confirmación de consulta #" + response2.data.data.event.id + " éxitosa!",
                    "message": confirmHTML({
                        clinic_name: response2.data.data.event.clinic.title,
                        clinic_address: response2.data.data.event.clinic.address,
                        clinic_address_2: response2.data.data.event.clinic.address_2,
                        clinic_city: response2.data.data.event.clinic.city ? response2.data.data.event.clinic.city : '',
                        clinic_country: response2.data.data.event.clinic.country ? response2.data.data.event.clinic.country : '',
                        clinic_phone: response2.data.data.event.clinic.phone[0] ? response2.data.data.event.clinic.phone[0] : '',
                        doctor_name: response2.data.data.event.doctor.first_name + ' ' + response2.data.data.event.doctor.last_name,
                        patient_id: response2.data.data.event.patient.id,
                        patient_name: response2.data.data.event.patient.first_name + " " + response2.data.data.event.patient.last_name,
                        patient_first_name: response2.data.data.event.patient.first_name,
                        doctor_id: response2.data.data.event.doctor.id,
                        consultation_id: response2.data.data.event.id,
                        date_time: new Date(response2.data.data.event.date).toLocaleDateString('es-ES', dateStringOptions) + ' a las ' +
                            new Date(response2.data.data.event.date).toLocaleTimeString('en-EN', timeStringOptions),
                    }),
                    "target": {
                        "email": { "$like": "%" + response2.data.data.event.patient.email + "%" }
                    }
                });

                var patient_phone = response2.data.data.event.patient.phone[0]
                var notifPayloadWA = JSON.stringify({
                    "type": "whatsapp",
                    "title": ("Confirmación de consulta No." + response2.data.data.event.id + " éxitosa!").toUnicode(),
                    "message": confirmWA({
                        clinic_name: response2.data.data.event.clinic.title,
                        clinic_address: response2.data.data.event.clinic.address,
                        clinic_address_2: response2.data.data.event.clinic.address_2,
                        clinic_city: response2.data.data.event.clinic.city ? response2.data.data.event.clinic.city : '',
                        clinic_country: response2.data.data.event.clinic.country ? response2.data.data.event.clinic.country : '',
                        clinic_phone: response2.data.data.event.clinic.phone[0] ? response2.data.data.event.clinic.phone[0] : '',
                        doctor_name: response2.data.data.event.doctor.first_name + ' ' + response2.data.data.event.doctor.last_name,
                        patient_id: response2.data.data.event.patient.id,
                        patient_name: response2.data.data.event.patient.first_name + " " + response2.data.data.event.patient.last_name,
                        patient_first_name: response2.data.data.event.patient.first_name,
                        doctor_id: response2.data.data.event.doctor.id,
                        consultation_id: response2.data.data.event.id,
                        date_time: new Date(response2.data.data.event.date).toLocaleDateString('es-ES', dateStringOptions) + ' a las ' +
                            new Date(response2.data.data.event.date).toLocaleTimeString('en-EN', timeStringOptions),
                    }).toUnicode(),
                    "url": ``,
                    "meta": {
                        "to": patient_phone
                    }
                });

                dispatch('sendNotificationPublic', notifPayload).then((response3) => {
                    dispatch('sendNotificationPublic', notifPayloadWA).then((response4) => {
                        resolve(response4);
                    }).catch((error) => { reject(error) });
                }).catch((error) => { reject(error) });


            });
        })

    },
    notifyEditSuccess({ dispatch, rootState }, payload) {
        //console.log('CONFIRM SUCCESS');
        //console.log('payload', payload)
        return new Promise((resolve, reject) => {
            dispatch('getConsultationByIdPublic', payload.data.data.event.id).then(response2 => {
                // notificacion
                var notifPayload = JSON.stringify({
                    "type": "email",
                    "title": "La consulta #" + response2.data.data.event.id + " fue editada!",
                    "message": notifyEditHTML_P({
                        clinic_name: response2.data.data.event.clinic.title,
                        clinic_address: response2.data.data.event.clinic.address,
                        clinic_address_2: response2.data.data.event.clinic.address_2,
                        clinic_city: response2.data.data.event.clinic.city ? response2.data.data.event.clinic.city : '',
                        clinic_country: response2.data.data.event.clinic.country ? response2.data.data.event.clinic.country : '',
                        clinic_phone: response2.data.data.event.clinic.phone[0] ? response2.data.data.event.clinic.phone[0] : '',
                        doctor_name: response2.data.data.event.doctor.first_name + ' ' + response2.data.data.event.doctor.last_name,
                        patient_id: response2.data.data.event.patient.id,
                        patient_name: response2.data.data.event.patient.first_name + " " + response2.data.data.event.patient.last_name,
                        patient_first_name: response2.data.data.event.patient.first_name,
                        doctor_id: response2.data.data.event.doctor.id,
                        consultation_id: response2.data.data.event.id,
                        date_time: new Date(response2.data.data.event.date).toLocaleDateString('es-ES', dateStringOptions) + ' a las ' +
                            new Date(response2.data.data.event.date).toLocaleTimeString('en-EN', timeStringOptions),
                    }),
                    "target": {
                        "email": { "$like": "%" + response2.data.data.event.patient.email + "%" }
                    }
                });
                dispatch('sendNotificationPublic', notifPayload)
                var patient_phone = response2.data.data.event.patient.phone[0]
                var notifPayloadWA = JSON.stringify({
                    "type": "whatsapp",
                    "title": ("La consulta No." + response2.data.data.event.id + " fue modificada!").toUnicode(),
                    "message": notifyEditWA_P({
                        clinic_name: response2.data.data.event.clinic.title,
                        clinic_address: response2.data.data.event.clinic.address,
                        clinic_address_2: response2.data.data.event.clinic.address_2,
                        clinic_city: response2.data.data.event.clinic.city ? response2.data.data.event.clinic.city : '',
                        clinic_country: response2.data.data.event.clinic.country ? response2.data.data.event.clinic.country : '',
                        clinic_phone: response2.data.data.event.clinic.phone[0] ? response2.data.data.event.clinic.phone[0] : '',
                        doctor_name: response2.data.data.event.doctor.first_name + ' ' + response2.data.data.event.doctor.last_name,
                        patient_id: response2.data.data.event.patient.id,
                        patient_name: response2.data.data.event.patient.first_name + " " + response2.data.data.event.patient.last_name,
                        patient_first_name: response2.data.data.event.patient.first_name,
                        doctor_id: response2.data.data.event.doctor.id,
                        consultation_id: response2.data.data.event.id,
                        date_time: new Date(response2.data.data.event.date).toLocaleDateString('es-ES', dateStringOptions) + ' a las ' +
                            new Date(response2.data.data.event.date).toLocaleTimeString('en-EN', timeStringOptions),
                    }).toUnicode(),
                    "meta": {
                        "to": patient_phone
                    },
                    "url": `https://app.evolugy.com/links/consultation/${response2.data.data.event.id}?action=edit`
                });
                dispatch('sendNotificationPublic', notifPayloadWA)
            });
            dispatch('sendNotificationPublic', notifPayloadWA)
        });
    },
    sendNotificationNewPatient({ dispatch, rootState }, payload) {

        return new Promise((resolve, reject) => {
            var notifPayload = JSON.stringify({
                "type": "email",
                "title": "Bienvenido a Evolugy",
                "message": newPatientHTML(payload),
                "target": { "email": { "$like": "%" + payload.email + "%" } }
            });
            dispatch('sendNotification', notifPayload).then((response2) => {
                console.log(response2);
                // verify if phone contains area code in first 3 characters
                var patient_phone = payload.phone[0];

                var notifPayloadWA = JSON.stringify({
                    "type": "whatsapp",
                    "title": "Bienvenido a Evolugy",
                    "message": newPatientWA(payload).toUnicode(),
                    "url": `https://app.evolugy.com/links/new-patient/${payload.doctor_id}/?pid=${payload.patient_id}`,
                    "meta": {
                        "to": patient_phone
                    },
                    "target": { "email": { "$like": "%" + payload.email + "%" } }
                });
                dispatch('sendNotification', notifPayloadWA).then((response3) => {
                    resolve(response3);
                }).catch((error) => { reject(error) });
            }).catch((error) => { reject(error) });
        }, error2 => {

            console.error(error2);

        });


    },
    sendNotificationEventEditted({ dispatch, rootState }, pyl) {


        return new Promise((resolve, reject) => {

            dispatch('getConsultationById', pyl).then(response => {

                // notificacion
                var payload = response.data.data.event;

                var notifPayload = JSON.stringify({
                    "type": "email",
                    "title": "Consulta Modificada",
                    "message": notifyEditHTML_D({
                        clinic_name: payload.clinic.title,
                        clinic_address: payload.clinic.address,
                        clinic_address_2: payload.clinic.address_2,
                        clinic_city: payload.clinic.city ? payload.clinic.city : '',
                        clinic_country: payload.clinic.country ? payload.clinic.country : '',
                        clinic_phone: payload.clinic.phone[0] ? payload.clinic.phone[0] : '',
                        doctor_name: payload.doctor.first_name + ' ' + payload.doctor.last_name,
                        patient_id: payload.patient.id,
                        patient_name: payload.patient.first_name + " " + payload.patient.last_name,
                        patient_first_name: payload.patient.first_name,
                        doctor_id: payload.doctor.id,
                        consultation_id: payload.id,
                        date_time: new Date(payload.date).toLocaleDateString('es-ES', dateStringOptions) + ' a las ' +
                            new Date(payload.date).toLocaleTimeString('en-EN', timeStringOptions),
                    }),
                    "target": { "email": { "$like": "%" + payload.patient.email + "%" } }
                });
                // verify if phone contains area code in first 3 characters
                var patient_phone = payload.patient.phone[0];

                var notifPayloadWA = JSON.stringify({
                    "type": "whatsapp",
                    "title": "Consulta Modificada",
                    "message": notifyEditHTML_DWA({
                        clinic_name: payload.clinic.title,
                        clinic_address: payload.clinic.address,
                        clinic_address_2: payload.clinic.address_2,
                        clinic_city: payload.clinic.city ? payload.clinic.city : '',
                        clinic_country: payload.clinic.country ? payload.clinic.country : '',
                        clinic_phone: payload.clinic.phone[0] ? payload.clinic.phone[0] : '',
                        doctor_name: payload.doctor.first_name + ' ' + payload.doctor.last_name,
                        patient_id: payload.patient.id,
                        patient_name: payload.patient.first_name + " " + payload.patient.last_name,
                        patient_first_name: payload.patient.first_name,
                        doctor_id: payload.doctor.id,
                        consultation_id: payload.id,
                        date_time: new Date(payload.date).toLocaleDateString('es-ES', dateStringOptions) + ' a las ' +
                            new Date(payload.date).toLocaleTimeString('en-EN', timeStringOptions),
                    }).toUnicode(),
                    "url": `https://app.evolugy.com/links/consultation/${payload.id}?action=edit`,
                    "meta": {
                        "to": patient_phone
                    }
                });

                dispatch('sendNotification', notifPayload).then((response2) => {
                    console.log('response2 ', response2);
                    dispatch('sendNotification', notifPayloadWA).then((response3) => {
                        resolve(response3);
                    }).catch((error) => { reject(error) });
                    // 
                }).catch((error) => { reject(error) });
            });

        }, error2 => {

            console.error(error2);

        });

    },
    sendNotificationConsultationReq({ dispatch, rootState }, payload) {

        return new Promise((resolve, reject) => {
            var notifPayload = JSON.stringify({
                "type": "email",
                "title": "Solicitud de Consulta",
                "message": consultationReqHTML(payload),
                "target": { "email": { "$like": "%" + payload.email + "%" } }
            });
            dispatch('sendNotification', notifPayload).then((response2) => {
                // verify if phone contains area code in first 3 characters
                var patient_phone = payload.phone[0];

                var notifPayloadWA = JSON.stringify({
                    "type": "whatsapp",
                    "title": "Solicitud de Consulta",
                    "message": consultationReqWA(payload).toUnicode(),
                    "url": `https://app.evolugy.com/links/consultation-request/${payload.patient_id}/${payload.doctor_id}`,
                    "meta": {
                        "to": patient_phone
                    },
                    "target": { "email": { "$like": "%" + payload.email + "%" } }
                });
                dispatch('sendNotification', notifPayloadWA).then((response3) => {
                    resolve(response3);
                }).catch((error) => { reject(error) });
                // 
            }).catch((error) => { reject(error) });
        }, error2 => {

            console.error(error2);

        });

    },
    notifyNewSecretaryCreation({ dispatch, rootState }, payload) {
        // notificacion
        const notifPayload = JSON.stringify({
            type: "email",
            title: "Secretaria #" + payload.secretary_id + " creada exitosamente!",
            message: newSecretaryHTML({
                doctor_name: payload.doctor_name,
                secretary_email: payload.secretary_email,
                secretary_id: payload.secretary_id,
                date: new Date(payload.created_at).toLocaleDateString('es-ES', dateStringOptions)
            }),
            target: {
                email: { $like: "%" + payload.secretary_email + "%" }
            }
        });
        return dispatch('sendNotificationPublic', notifPayload);
    },
    notifyNewConsultationScheduled({ dispatch, rootState }, payload) {
        // notificacion
        return new Promise((resolve, reject) => {
            const notifPayload = JSON.stringify({
                type: "email",
                title: payload.title,
                message: consultationScheHTML(
                    payload
                ),
                target: {
                    email: { $like: "%" + payload.patient_email + "%" }
                }
            });
            dispatch('sendNotificationPublic', notifPayload).then((response) => {
                console.log(payload.phone)
                var patient_phone = payload.phone;
                const notifPayloadWA = JSON.stringify({
                    type: "whatsapp",
                    title: payload.title,
                    message: consultationScheWA(
                        payload
                    ).toUnicode(),
                    meta: {
                        to: patient_phone
                    },
                    url: ''
                });
                console.log(notifPayloadWA)
                return dispatch('sendNotificationPublic', notifPayloadWA).then((response2) => {
                    resolve(response2)
                })
            }).catch((error) => { reject(error) });
        });

    },

    notifyLinkSecretary({ dispatch, rootState }, payload) {
        // notificacion
        const notifPayload = JSON.stringify({
            type: "email",
            title: "Secretaria vinculada exitosamente!",
            message: existingSecretaryHTML({
                doctor_name: payload.doctor_name,
                secretary_email: payload.secretary_email,
                date: new Date().toLocaleDateString('es-ES', dateStringOptions)
            }),
            target: {
                email: { $like: "%" + payload.secretary_email + "%" }
            }
        });
        dispatch('sendNotificationPublic', notifPayload).then((response) => {
            var secretary_phone = payload.phone[0]
            const notifPayloadWA = JSON.stringify({
                type: "whatsapp",
                title: "Secretaria vinculada exitosamente!",
                message: existingSecretaryWA({
                    doctor_name: payload.doctor_name,
                    secretary_email: payload.secretary_email,
                    date: new Date().toLocaleDateString('es-ES', dateStringOptions)
                }).toUnicode(),
                meta: {
                    to: secretary_phone
                }
            });
            return dispatch('sendNotificationPublic', notifPayloadWA);
        })
    },
    notifyFinishSuccess({ dispatch, rootState }, payload) {
        //console.log('notifyFinishSuccess');
        return new Promise((resolve, reject) => {
            //  recordatorio
            dispatch('getConsultationById', payload.data.data.event.id).then(response2 => {
                //console.log(payload.data.data.event.instructions)
                var notifPayload = JSON.stringify({
                    "type": "email",
                    "title": "Consulta #" + response2.data.data.event.id + " finalizada exitosamente!",
                    "message": summaryHTML({
                        clinic_name: response2.data.data.event.clinic.title,
                        clinic_address: response2.data.data.event.clinic.address,
                        clinic_address_2: response2.data.data.event.clinic.address_2,
                        clinic_city: response2.data.data.event.clinic.city ? response2.data.data.event.clinic.city : '',
                        clinic_country: response2.data.data.event.clinic.country ? response2.data.data.event.clinic.country : '',
                        clinic_phone: response2.data.data.event.clinic.phone[0] ? response2.data.data.event.clinic.phone[0] : '',
                        doctor_name: response2.data.data.event.doctor.first_name + ' ' + response2.data.data.event.doctor.last_name,
                        patient_id: response2.data.data.event.patient.id,
                        patient_name: response2.data.data.event.patient.first_name + " " + response2.data.data.event.patient.last_name,
                        patient_first_name: response2.data.data.event.patient.first_name,
                        doctor_id: response2.data.data.event.doctor.id,
                        consultation_id: response2.data.data.event.id,
                        date_time: new Date(response2.data.data.event.date).toLocaleDateString('es-ES', dateStringOptions) + ' a las ' +
                            new Date(response2.data.data.event.date).toLocaleTimeString('en-EN', timeStringOptions),
                        event: response2.data.data.event,
                        instructions: payload.data.data.event.instructions,
                        event_id: response2.data.data.event.id
                    }),
                    "target": {
                        "email": { "$like": "%" + response2.data.data.event.patient.email + "%" }
                    }
                });
                //console.log(notifPayload);

                dispatch('sendNotification', notifPayload).then((response) => {
                    var patient_phone = response2.data.data.event.patient.phone[0];
                    //console.log(payload.data.data.event.instructions)
                    var notifPayloadWA = JSON.stringify({
                        "type": "whatsapp",
                        "title": "Consulta No." + response2.data.data.event.id + " finalizada exitosamente!",
                        "message": summaryWA({
                            clinic_name: response2.data.data.event.clinic.title,
                            clinic_address: response2.data.data.event.clinic.address,
                            clinic_address_2: response2.data.data.event.clinic.address_2,
                            clinic_city: response2.data.data.event.clinic.city ? response2.data.data.event.clinic.city : '',
                            clinic_country: response2.data.data.event.clinic.country ? response2.data.data.event.clinic.country : '',
                            clinic_phone: response2.data.data.event.clinic.phone[0] ? response2.data.data.event.clinic.phone[0] : '',
                            doctor_name: response2.data.data.event.doctor.first_name + ' ' + response2.data.data.event.doctor.last_name,
                            patient_id: response2.data.data.event.patient.id,
                            patient_name: response2.data.data.event.patient.first_name + " " + response2.data.data.event.patient.last_name,
                            patient_first_name: response2.data.data.event.patient.first_name,
                            doctor_id: response2.data.data.event.doctor.id,
                            consultation_id: response2.data.data.event.id,
                            date_time: new Date(response2.data.data.event.date).toLocaleDateString('es-ES', dateStringOptions) + ' a las ' +
                                new Date(response2.data.data.event.date).toLocaleTimeString('en-EN', timeStringOptions),
                            event: response2.data.data.event,
                            instructions: payload.data.data.event.instructions
                        }).toUnicode(),
                        "url": `https://app.evolugy.com/links/recipe/view/${response2.data.data.event.doctor.id}/${response2.data.data.event.meta.prescription_id}`,
                        "meta": {
                            "to": patient_phone
                        }
                    })
                    dispatch('sendNotification', notifPayloadWA).then((response2) => {
                        resolve(response2);

                    }).catch(function(error) {
                        reject(error);
                    })


                })

                .catch(function(error) {
                    reject(error);

                });

                /* var notifPayloadWA = JSON.stringify({
                        "type": "whatsapp",
                        "title": "Consulta #" + response2.data.data.event.id + " finalizada exitosamente!",
                        "message": summaryWA({
                            clinic_name: response2.data.data.event.clinic.title,
                            clinic_address: response2.data.data.event.clinic.address,
                            clinic_address_2: response2.data.data.event.clinic.address_2,
                            clinic_city: response2.data.data.event.clinic.city ? response2.data.data.event.clinic.city : '',
                            clinic_country: response2.data.data.event.clinic.country ? response2.data.data.event.clinic.country : '',
                            clinic_phone: response2.data.data.event.clinic.phone[0] ? response2.data.data.event.clinic.phone[0] : '',
                            doctor_name: response2.data.data.event.doctor.first_name + ' ' + response2.data.data.event.doctor.last_name,
                            patient_id: response2.data.data.event.patient.id,
                            patient_name: response2.data.data.event.patient.first_name + " " + response2.data.data.event.patient.last_name,
                            patient_first_name: response2.data.data.event.patient.first_name,
                            doctor_id: response2.data.data.event.doctor.id,
                            consultation_id: response2.data.data.event.id,
                            date_time: new Date(response2.data.data.event.date).toLocaleDateString('es-ES', dateStringOptions) + ' a las ' +
                                new Date(response2.data.data.event.date).toLocaleTimeString('en-EN', timeStringOptions),
                            event: response2.data.data.event,
                        }),
                        "url": ``,
                        "meta": {
                            "to": "+502" + response2.data.data.event.patient.phone[0]
                        },
                        "target": {
                            "email": { "$like": "%" + response2.data.data.event.patient.email + "%" }
                        }
                    });
                    //console.log(notifPayload);
    
                    dispatch('sendNotification', notifPayloadWA).then((response) => {
    
                            resolve(response);
    
                        })
                        
                        .catch(function(error) {
                            reject(error);
                            
                        }); */

            }, error2 => {

                console.error(error2);

            });
        });


    },
    notifyAnnulation({ dispatch, rootState }, payload) {
        //console.log('notifyFinishSuccess');
        return new Promise((resolve, reject) => {
            // notification
            var notifPayload = JSON.stringify({
                "type": "email",
                "title": "Consulta #" + payload.id + " anulada!",
                "message": annulationHTML({
                    clinic_title: payload.clinic_title,
                    clinic_address: payload.clinic_address,
                    clinic_address_2: payload.clinic_address_2,
                    clinic_city: payload.clinic_city,
                    clinic_country: payload.clinic_country,
                    clinic_phone: payload.clinic_phone,
                    doctor_name: payload.doctor_first_name + ' ' + payload.doctor_last_name,
                    patient_id: payload.patient_id,
                    patient_name: payload.patient_first_name + " " + payload.patient_last_name,
                    patient_first_name: payload.patient_first_name,
                    doctor_id: payload.doctor_id,
                    consultation_id: payload.id,
                    date_time: new Date(payload.event_date).toLocaleDateString('es-ES', dateStringOptions) + ' a las ' +
                        new Date(payload.event_date).toLocaleTimeString('en-EN', timeStringOptions)
                }),
                "target": {
                    "email": { "$like": "%" + payload.patient_email + "%" }
                }
            });
            //console.log(notifPayload);

            dispatch('sendNotification', notifPayload).then((response) => {

                    // verify if phone contains area code in first 3 characters


                    var notifPayloadWA = JSON.stringify({
                        "type": "whatsapp",
                        "title": "Consulta No." + payload.id + " anulada!",
                        "message": annulationWA({
                            clinic_title: payload.clinic_title,
                            clinic_address: payload.clinic_address,
                            clinic_address_2: payload.clinic_address_2,
                            clinic_city: payload.clinic_city,
                            clinic_country: payload.clinic_country,
                            clinic_phone: payload.clinic_phone,
                            doctor_name: payload.doctor_first_name + ' ' + payload.doctor_last_name,
                            patient_id: payload.patient_id,
                            patient_name: payload.patient_first_name + " " + payload.patient_last_name,
                            patient_first_name: payload.patient_first_name,
                            doctor_id: payload.doctor_id,
                            consultation_id: payload.id,
                            date_time: new Date(payload.event_date).toLocaleDateString('es-ES', dateStringOptions) + ' a las ' +
                                new Date(payload.event_date).toLocaleTimeString('en-EN', timeStringOptions)
                        }).toUnicode(),
                        "url": ``,
                        "meta": {
                            "to": patient_phone
                        }
                    });
                    //console.log(notifPayload);

                    dispatch('sendNotification', notifPayloadWA).then((response2) => {
                            resolve(response2);
                        })
                        .catch(function(error) {
                            reject(error);
                        });

                })
                .catch(function(error) {
                    reject(error);
                });

        });


    },
    // ------------------------
    // ----- EVENT ACTIONS -----
    // -------------------------
    addEventType({ dispatch, rootState }, payload) {
        var isDoctor = rootState.AppActiveUser.role == "doctor" ? true : false;
        return new Promise((resolve, reject) => {
            var config = {
                method: 'post',
                url: eventsApiUrl,
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken
                },
                data: payload
            };
            axios(config).then(function(response) {
                resolve(response)
            })
            
        })
        
    },
    addEvent({ dispatch, rootState }, payload) {
        var isDoctor = rootState.AppActiveUser.role == "doctor" ? true : false;

        return new Promise((resolve, reject) => {
            var config = {
                method: 'post',
                url: eventsApiUrl,
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken
                },
                data: payload
            };
            axios(config)
                .then(function(response) {
                    // FETCH EVENTS
                    dispatch('fetchEvents');
                    //console.log(response.data);

                    // SETUP -24hrs NOTIFICATION
                    // get clinic details
                    dispatch('getConsultationById', response.data.data.event.id).then(response2 => {

                        //console.log('response2: ',response2);
                        var tempDate = new Date(response2.data.data.event.date);
                        tempDate.setDate(tempDate.getDate() - 1);
                        var nowDate = new Date();
                        var diffHours = (tempDate - nowDate) / 36e5;
                        console.log(diffHours);
                        if (diffHours <= 0) {
                            tempDate = nowDate;
                        }
                        //console.log(tempDate);
                        //console.log(getDateTimeZone(tempDate));

                        var isVirtual = response2.data.data.event.type == 'virtual_consultation' && response2.data.data.event.meeting_url_base;


                        //  recordatorio
                        var notifPayload = JSON.stringify({
                            "type": "email",
                            "title": "Recordatorio de consulta #" + response2.data.data.event.id,
                            "message": reminderHTML({
                                clinic_name: response2.data.data.event.clinic.title,
                                clinic_address: response2.data.data.event.clinic.address,
                                clinic_address_2: response2.data.data.event.clinic.address_2,
                                clinic_city: response2.data.data.event.clinic.city ? response2.data.data.event.clinic.city : '',
                                clinic_country: response2.data.data.event.clinic.country ? response2.data.data.event.clinic.country : '',
                                clinic_phone: response2.data.data.event.clinic.phone[0] ? response2.data.data.event.clinic.phone[0] : '',
                                doctor_name: isDoctor ? rootState.AppActiveUser.first_name + ' ' + rootState.AppActiveUser.last_name : rootState.activeDoctor.first_name + ' ' + rootState.activeDoctor.last_name,
                                patient_id: response2.data.data.event.patient.id,
                                patient_name: response2.data.data.event.patient.first_name + " " + response2.data.data.event.patient.last_name,
                                patient_first_name: response2.data.data.event.patient.first_name,
                                doctor_id: isDoctor ? rootState.AppActiveUser.id : rootState.activeDoctor.id,
                                consultation_id: response2.data.data.event.id,
                                date_time: new Date(response2.data.data.event.date).toLocaleDateString('es-ES', dateStringOptions) + ' a las ' +
                                    new Date(response2.data.data.event.date).toLocaleTimeString('en-EN', timeStringOptions),
                                isVirtual: isVirtual,
                                meeting_url: isVirtual ? response2.data.data.event.meeting_url_base : ''
                            }),
                            "date": getDateTimeZone(tempDate),
                            "target": {
                                "email": { "$like": "%" + response2.data.data.event.patient.email + "%" }
                            }
                        });
                        dispatch('sendNotification', notifPayload).then(response3 => {
                            // ------------------------
                            // confirmacion consulta email y whatsapp
                            // ------------------------
                            // si esta activo o no mandar diferente notificacion
                            if (response2.data.data.event.patient.active && response2.data.data.event.type == "consultation") {
                                console.log('ENTRO!');
                                // Si el paciente esta activo cuando se crea la consulta - mandar confirmacion
                                var confirmNotifPayload = JSON.stringify({
                                    "type": "email",
                                    "title": "Nueva consulta #" + response2.data.data.event.id,
                                    "message": confirmConHTML({
                                        clinic_name: response2.data.data.event.clinic.title,
                                        clinic_address: response2.data.data.event.clinic.address,
                                        clinic_address_2: response2.data.data.event.clinic.address_2,
                                        clinic_city: response2.data.data.event.clinic.city ? response2.data.data.event.clinic.city : '',
                                        clinic_country: response2.data.data.event.clinic.country ? response2.data.data.event.clinic.country : '',
                                        clinic_phone: response2.data.data.event.clinic.phone[0] ? response2.data.data.event.clinic.phone[0] : '',
                                        doctor_name: isDoctor ? rootState.AppActiveUser.first_name + ' ' + rootState.AppActiveUser.last_name : rootState.activeDoctor.first_name + ' ' + rootState.activeDoctor.last_name,
                                        patient_id: response2.data.data.event.patient.id,
                                        patient_name: response2.data.data.event.patient.first_name + " " + response2.data.data.event.patient.last_name,
                                        patient_first_name: response2.data.data.event.patient.first_name,
                                        doctor_id: isDoctor ? rootState.AppActiveUser.id : rootState.activeDoctor.id,
                                        consultation_id: response2.data.data.event.id,
                                        date_time: new Date(response2.data.data.event.date).toLocaleDateString('es-ES', dateStringOptions) + ' a las ' +
                                            new Date(response2.data.data.event.date).toLocaleTimeString('en-EN', timeStringOptions),
                                        isVirtual: isVirtual,
                                        meeting_url: isVirtual ? response2.data.data.event.meeting_url_base : ''
                                    }),
                                    "target": {
                                        "email": { "$like": "%" + response2.data.data.event.patient.email + "%" }
                                    }
                                });

                                // whatsapp
                                // verify if phone contains area code in first 3 characters

                                var patient_phone = response2.data.data.event.patient.phone[0];
                                console.log('telefono!: ', response2.data.data.event.patient.phone[0], ' ', patient_phone);

                                var confirmNotifPayloadWA = JSON.stringify({
                                    "type": "whatsapp",
                                    "title": "Nueva consulta\n",
                                    "message": confirmConWA({
                                        clinic_name: response2.data.data.event.clinic.title,
                                        event_id: response2.data.data.event.id,
                                        clinic_address: response2.data.data.event.clinic.address,
                                        clinic_address_2: response2.data.data.event.clinic.address_2,
                                        clinic_city: response2.data.data.event.clinic.city ? response2.data.data.event.clinic.city : '',
                                        clinic_country: response2.data.data.event.clinic.country ? response2.data.data.event.clinic.country : '',
                                        clinic_phone: response2.data.data.event.clinic.phone[0] ? response2.data.data.event.clinic.phone[0] : '',
                                        doctor_name: isDoctor ? rootState.AppActiveUser.first_name + ' ' + rootState.AppActiveUser.last_name : rootState.activeDoctor.first_name + ' ' + rootState.activeDoctor.last_name,
                                        patient_id: response2.data.data.event.patient.id,
                                        patient_name: response2.data.data.event.patient.first_name + " " + response2.data.data.event.patient.last_name,
                                        patient_first_name: response2.data.data.event.patient.first_name,
                                        doctor_id: isDoctor ? rootState.AppActiveUser.id : rootState.activeDoctor.id,
                                        consultation_id: response2.data.data.event.id,
                                        date_time: new Date(response2.data.data.event.date).toLocaleDateString('es-ES', dateStringOptions) + ' a las ' +
                                            new Date(response2.data.data.event.date).toLocaleTimeString('en-EN', timeStringOptions),
                                        date: new Date(response2.data.data.event.date).toLocaleDateString('es-ES', dateStringOptions),
                                        time: new Date(response2.data.data.event.date).toLocaleTimeString('en-EN', timeStringOptions),
                                        isVirtual: isVirtual,
                                        meeting_url: isVirtual ? response2.data.data.event.meeting_url_base : ''
                                    }).toUnicode(),
                                    "url": `https://app.evolugy.com/links/consultation/${response2.data.data.event.id}?action=confirm`,
                                    "meta": {
                                        "to": patient_phone
                                    }
                                });

                                dispatch('sendNotification', confirmNotifPayload).then(response4 => {
                                    dispatch('sendNotification', confirmNotifPayloadWA).then(response5 => {
                                        resolve(response);
                                    });
                                });




                            } else if (!response2.data.data.event.patient.active) {
                                console.log('ENTRO!');
                                // si el paciente no esta activo mandar a link de consulta+nuevo paciente
                                var isVirtual = response2.data.data.event.type == 'virtual_consultation' && response2.data.data.event.meeting_url_base;
                                var confirmNotifPayload = JSON.stringify({
                                    "type": "email",
                                    "title": "Nueva consulta #" + response2.data.data.event.id,
                                    "message": consultationPatientHTML({
                                        clinic_name: response2.data.data.event.clinic.title,
                                        clinic_address: response2.data.data.event.clinic.address,
                                        clinic_address_2: response2.data.data.event.clinic.address_2,
                                        clinic_city: response2.data.data.event.clinic.city ? response2.data.data.event.clinic.city : '',
                                        clinic_country: response2.data.data.event.clinic.country ? response2.data.data.event.clinic.country : '',
                                        clinic_phone: response2.data.data.event.clinic.phone[0] ? response2.data.data.event.clinic.phone[0] : '',
                                        doctor_name: isDoctor ? rootState.AppActiveUser.first_name + ' ' + rootState.AppActiveUser.last_name : rootState.activeDoctor.first_name + ' ' + rootState.activeDoctor.last_name,
                                        patient_id: response2.data.data.event.patient.id,
                                        patient_name: response2.data.data.event.patient.first_name + " " + response2.data.data.event.patient.last_name,
                                        patient_first_name: response2.data.data.event.patient.first_name,
                                        doctor_id: isDoctor ? rootState.AppActiveUser.id : rootState.activeDoctor.id,
                                        consultation_id: response2.data.data.event.id,
                                        date: new Date(response2.data.data.event.date).toLocaleDateString('es-ES', dateStringOptions),
                                        time: new Date(response2.data.data.event.date).toLocaleTimeString('en-EN', timeStringOptions),
                                        isVirtual: isVirtual,
                                        meeting_url: isVirtual ? response2.data.data.event.meeting_url_base : ''
                                    }),
                                    "target": {
                                        "email": { "$like": "%" + response2.data.data.event.patient.email + "%" }
                                    }
                                });

                                // whatsapp
                                // verify if phone contains area code in first 3 characters
                                var patient_phone = response2.data.data.event.patient.phone[0];

                                var confirmNotifPayloadWA = JSON.stringify({
                                    "type": "whatsapp",
                                    "title": "Nueva consulta No." + response2.data.data.event.id,
                                    "message": consultationPatientWA({
                                        clinic_name: response2.data.data.event.clinic.title,
                                        clinic_address: response2.data.data.event.clinic.address,
                                        clinic_address_2: response2.data.data.event.clinic.address_2,
                                        clinic_city: response2.data.data.event.clinic.city ? response2.data.data.event.clinic.city : '',
                                        clinic_country: response2.data.data.event.clinic.country ? response2.data.data.event.clinic.country : '',
                                        clinic_phone: response2.data.data.event.clinic.phone[0] ? response2.data.data.event.clinic.phone[0] : '',
                                        doctor_name: isDoctor ? rootState.AppActiveUser.first_name + ' ' + rootState.AppActiveUser.last_name : rootState.activeDoctor.first_name + ' ' + rootState.activeDoctor.last_name,
                                        patient_id: response2.data.data.event.patient.id,
                                        patient_name: response2.data.data.event.patient.first_name + " " + response2.data.data.event.patient.last_name,
                                        patient_first_name: response2.data.data.event.patient.first_name,
                                        doctor_id: isDoctor ? rootState.AppActiveUser.id : rootState.activeDoctor.id,
                                        consultation_id: response2.data.data.event.id,
                                        date: new Date(response2.data.data.event.date).toLocaleDateString('es-ES', dateStringOptions),
                                        time: new Date(response2.data.data.event.date).toLocaleTimeString('en-EN', timeStringOptions),
                                        isVirtual: isVirtual,
                                        meeting_url: isVirtual ? response2.data.data.event.meeting_url_base : ''
                                    }).toUnicode(),
                                    "url": `https://app.evolugy.com/links/consultation/${response2.data.data.event.id}?action=newPatient`,
                                    "meta": {
                                        "to": patient_phone
                                    },
                                    "target": {
                                        "email": { "$like": "%" + response2.data.data.event.patient.email + "%" }
                                    }
                                });
                                dispatch('sendNotification', confirmNotifPayload).then(response4 => {
                                    dispatch('sendNotification', confirmNotifPayloadWA).then(response5 => {
                                        resolve(response5);
                                    });
                                });
                            }
                        });


                    }, error2 => {

                        console.error(error2);

                    });



                })
                .catch(function(error) {
                    console.log(error);
                    reject(error);
                });
        });
    },
    addEventPublic({ dispatch, rootState }, payload, sendConfirm) {
        return new Promise((resolve, reject) => {
            axios.post(cloudFunctionUrl, {})
                .then((response) => {
                    //console.log(response);
                    let adminToken = response.data.user.stsTokenManager.accessToken;

                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + adminToken
                    }
                    var config = {
                        method: 'post',
                        url: eventsApiUrl,
                        headers: headers,
                        data: payload
                    };
                    axios(config)
                        .then((response) => {
                            //console.log('RESPONSE: ',response.data);

                            var tempDate = new Date(response.data.data.event.date);
                            tempDate.setDate(tempDate.getDate() - 1);
                            var nowDate = new Date();
                            var diffHours = (tempDate - nowDate) / 36e5;
                            console.log(diffHours);
                            if (diffHours <= 0) {
                                tempDate = nowDate;
                            }

                            //console.log(tempDate);
                            //console.log(getDateTimeZone(tempDate));
                            var isVirtual = response.data.data.event.type == 'virtual_consultation' && response.data.data.event.meeting_url_base;

                            // enviamos notificación de confirmación: 
                            // --- notification ---
                            var confirmNotifPayload = JSON.stringify({
                                "type": "email",
                                "title": "Nueva consulta #" + response.data.data.event.id,
                                "message": confirmConHTML({
                                    clinic_name: payload.clinic_name,
                                    clinic_address: payload.clinic_address,
                                    clinic_address_2: payload.clinic_address_2,
                                    clinic_city: payload.clinic_city,
                                    clinic_country: payload.clinic_country,
                                    clinic_phone: payload.clinic_phone,
                                    doctor_name: payload.doctor_first_name + ' ' + payload.doctor_last_name,
                                    patient_id: response.data.data.event.patient_id,
                                    patient_name: payload.patient_first_name + " " + payload.patient_last_name,
                                    patient_first_name: payload.patient_first_name,
                                    doctor_id: response.data.data.event.doctor_id,
                                    consultation_id: response.data.data.event.id,
                                    date_time: new Date(response.data.data.event.date).toLocaleDateString('es-ES', dateStringOptions) + ' a las ' +
                                        new Date(response.data.data.event.date).toLocaleTimeString('en-EN', timeStringOptions),
                                    isVirtual: isVirtual,
                                    meeting_url: isVirtual ? response.data.data.event.meeting_url_base : ''
                                }),
                                "target": {
                                    "email": { "$like": "%" + payload.patient_email + "%" }
                                }
                            });

                            dispatch('sendNotificationPublic', confirmNotifPayload).then((response3) => {
                                //  recordatorio
                                var notifPayload = JSON.stringify({
                                    "type": "email",
                                    "title": "Recordatorio de consulta #" + response.data.data.event.id,
                                    "message": reminderHTML({
                                        clinic_name: payload.clinic_name,
                                        clinic_address: payload.clinic_address,
                                        clinic_address_2: payload.clinic_address_2,
                                        clinic_city: payload.clinic_city,
                                        clinic_country: payload.clinic_country,
                                        clinic_phone: payload.clinic_phone,
                                        doctor_name: payload.doctor_first_name + ' ' + payload.doctor_last_name,
                                        patient_id: response.data.data.event.patient_id,
                                        patient_name: payload.patient_first_name + " " + payload.patient_last_name,
                                        patient_first_name: payload.patient_first_name,
                                        doctor_id: response.data.data.event.doctor_id,
                                        consultation_id: response.data.data.event.id,
                                        date_time: new Date(response.data.data.event.date).toLocaleDateString('es-ES', dateStringOptions) + ' a las ' +
                                            new Date(response.data.data.event.date).toLocaleTimeString('en-EN', timeStringOptions),
                                        isVirtual: isVirtual,
                                        meeting_url: isVirtual ? response.data.data.event.meeting_url_base : ''
                                    }),
                                    "date": getDateTimeZone(tempDate),
                                    "target": {
                                        "email": { "$like": "%" + payload.patient_email + "%" }
                                    }
                                });
                                try {
                                    dispatch('sendNotificationPublic', notifPayload).then((response2) => {
                                        resolve(response);
                                    });
                                } catch (error) {
                                    resolve(response);
                                }
                            }).catch((error) => {

                                console.log(error);
                                reject(error);


                            });

                        })
                        .catch(function(error) {
                            console.log(error);
                            reject(error);
                        });
                })
                .catch((error) => { reject(error) });
            // --
        });
    },
    fetchEvents({ commit, rootState }, payload) {
        var fetchEventsURL;

        if (rootState.AppActiveUser.role == "doctor") {
            fetchEventsURL = eventsApiUrl + '/?perPage=150&currentPage=1&doctor_id=' + rootState.AppActiveUser.id;
        } else {
            fetchEventsURL = eventsApiUrl + '/?perPage=150&currentPage=1&doctor_id=' + sessionStorage.getItem('activeDoctorId');
        }

        if (payload && payload.start_date) {
            fetchEventsURL += `&start_date=${payload.start_date}`;
        }
        if (payload && payload.end_date) {
            fetchEventsURL += `&end_date=${payload.end_date}`;
        }

        return new Promise((resolve, reject) => {
            var config = {
                method: 'get',
                url: fetchEventsURL,
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken
                }
            };

            axios(config)
                .then(function(response) {
                    //console.log(response.data);

                    // filtrar users where type = virtual_consultation or consultation
                    var consultations = response.data.data.events.filter(obj => {
                        return (obj.type == "virtual_consultation") ||
                            (obj.type == "consultation")
                    });

                    var pending_consultations = response.data.data.events.filter(obj => {
                        return ((obj.type == "virtual_consultation") ||
                            (obj.type == "consultation") && (obj.meta.status == "Nueva" || obj.meta.status == "Solicitud"))
                    });

                    var canceled_consultations = response.data.data.events.filter(obj => {
                        return ((obj.type == "virtual_consultation") ||
                            (obj.type == "consultation") && (obj.meta.status == "Anulada"))
                    });

                    var confirmed_consultations = response.data.data.events.filter(obj => {
                        return ((obj.type == "virtual_consultation") ||
                            (obj.type == "consultation") && (obj.meta.status == "Confirmada"))
                    });

                    //console.log('PENDING. ', pending_consultations.length)

                    // Define total income
                    var paidConsultations = response.data.data.events.filter(obj => {
                        return ((obj.type == "virtual_consultation") || (obj.type == "consultation")) &&
                            (obj.meta.consultationTotal) && (obj.meta.paymentMethod) && (obj.meta.paid)
                    });

                    // var events = response.data.data.events.filter(obj => {
                    //     return obj.doctor_id == rootState.AppActiveUser.id
                    // });


                    commit('SET_CONSULTATIONS', consultations);

                    commit('SET_NUM_CONSULTATIONS', consultations.length);

                    commit('SET_NUM_PENDING_CONSULTATIONS', pending_consultations.length);

                    commit('SET_NUM_CONFIRMED_CONSULTATIONS', confirmed_consultations.length);

                    commit('SET_NUM_CANCELED_CONSULTATIONS', canceled_consultations.length);

                    commit('SET_PAID_CONSULTATIONS', paidConsultations);

                    commit('SET_EVENTS', response.data.data.events);

                    resolve(response);

                })
                .catch(function(error) {
                    console.log(error);
                    reject(error);
                });
        });
    },
    fetchEventsPublic({ commit, rootState }, id) {
        var fetchEventsURL = eventsApiUrl + '/?perPage=200&currentPage=1&doctor_id=' + id;

        return new Promise((resolve, reject) => {

            axios.post(cloudFunctionUrl, {})
                .then((response) => {
                    //console.log(response);
                    let adminToken = response.data.user.stsTokenManager.accessToken;

                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + adminToken
                    }
                    var config = {
                        method: 'get',
                        url: fetchEventsURL,
                        headers: headers
                    };
                    axios(config)
                        .then(function(response) {
                            //console.log(response.data);

                            // filtrar users where type = virtual_consultation or consultation
                            var consultations = response.data.data.events.filter(obj => {
                                return (obj.type == "virtual_consultation") ||
                                    (obj.type == "consultation")
                            });

                            // Define total income
                            var paidConsultations = response.data.data.events.filter(obj => {
                                return ((obj.type == "virtual_consultation") || (obj.type == "consultation")) &&
                                    (obj.meta.consultationTotal) && (obj.meta.paymentMethod) && (obj.meta.paid)
                            });

                            // var events = response.data.data.events.filter(obj => {
                            //     return obj.doctor_id == rootState.AppActiveUser.id
                            // });


                            commit('SET_CONSULTATIONS', consultations);

                            commit('SET_NUM_CONSULTATIONS', consultations.length);

                            commit('SET_PAID_CONSULTATIONS', paidConsultations);

                            commit('SET_EVENTS', response.data.data.events);

                            resolve(response);

                        })
                        .catch(function(error) {
                            console.log(error);
                            reject(error);
                        });
                })
                .catch((error) => { reject(error) });
            // --

        });
    },
    // CLINIC
    getClinicById({ commit, rootState }, id) {
        return new Promise((resolve, reject) => {
            var config = {
                method: 'get',
                url: clinicsUrl + '/' + id,
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken
                }
            };

            axios(config)
                .then(function(response) {
                    // console.log(response.data);

                    resolve(response);

                })
                .catch(function(error) {
                    console.log(error);
                    reject(error);
                });
        });
    },
    getConsultationById({ commit, rootState }, id) {
        return new Promise((resolve, reject) => {
            var config = {
                method: 'get',
                url: eventsApiUrl + '/' + id,
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken
                }
            };

            axios(config)
                .then(function(response) {
                    // console.log(response.data);

                    commit('SET_ACTIVE_CONSULTATION', response.data.data.event);

                    resolve(response);

                })
                .catch(function(error) {
                    console.log(error);
                    reject(error);
                });
        });
    },
    getConsultationByIdPublic({ commit, rootState }, id) {
        return new Promise((resolve, reject) => {
            axios.post(cloudFunctionUrl, {})
                .then((response) => {
                    //console.log(response);
                    let adminToken = response.data.user.stsTokenManager.accessToken;

                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + adminToken
                    }
                    var config = {
                        method: 'get',
                        url: eventsApiUrl + '/' + id,
                        headers: headers
                    };

                    axios(config)
                        .then(function(response) {
                            // console.log(response.data);

                            commit('SET_PUBLIC_CONSULTATION', response.data.data.event);

                            resolve(response);

                        })
                        .catch(function(error) {
                            console.log(error);
                            reject(error);
                        });

                })
                .catch((error) => { reject(error) });
        });
    },
    getUserDataByIdPublic({ commit, rootState }, id) {
        return new Promise((resolve, reject) => {
            axios.post(cloudFunctionUrl, {})
                .then((response) => {
                    //console.log(response);
                    let adminToken = response.data.user.stsTokenManager.accessToken;

                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + adminToken
                    }
                    var config = {
                        method: 'get',
                        url: usersApiUrl + '/' + id,
                        headers: headers
                    };

                    axios(config)
                        .then(function(response) {
                            // console.log(response.data);
                            if (response.data.data.user.role == 'patient') {
                                commit('SET_PUBLIC_PATIENT', response.data.data.user);
                            }
                            if (response.data.data.user.role == 'doctor') {
                                commit('SET_PUBLIC_DOCTOR', response.data.data.user);
                            }

                            resolve(response);

                        })
                        .catch(function(error) {
                            console.log(error);
                            reject(error);
                        });

                })
                .catch((error) => { reject(error) });

        });
    },
    getUserDataByEmailPublic({ commit, rootState }, email) {
        return new Promise((resolve, reject) => {
            axios.post(cloudFunctionUrl, {})
                .then((response) => {
                    //console.log(response);
                    let adminToken = response.data.user.stsTokenManager.accessToken;

                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + adminToken
                    }
                    var config = {
                        method: 'get',
                        url: usersApiUrl + 'email/' + email,
                        headers: headers
                    };

                    axios(config)
                        .then(function(response) {
                            // console.log(response.data);
                            if (response.data.data.user.role == 'patient') {
                                commit('SET_PUBLIC_PATIENT', response.data.data.user);
                            }
                            if (response.data.data.user.role == 'doctor') {
                                commit('SET_PUBLIC_DOCTOR', response.data.data.user);
                            }

                            resolve(response);

                        })
                        .catch(function(error) {
                            console.log(error);
                            reject(error);
                        });

                })
                .catch((error) => { reject(error) });

        });
    },
    getUserDataById({ commit, rootState }, id) {
        return new Promise((resolve, reject) => {
            var config = {
                method: 'get',
                url: usersApiUrl + '/' + id,
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken
                }
            };

            axios(config)
                .then(function(response) {
                    // console.log(response.data);

                    resolve(response);

                })
                .catch(function(error) {
                    console.log(error);
                    reject(error);
                });
        });

    },
    getDoctorDataById({ commit, rootState }, id) {
        return new Promise((resolve, reject) => {
            var config = {
                method: 'get',
                url: usersApiUrl + '/' + id,
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken
                }
            };

            axios(config)
                .then(function(response) {
                    // console.log(response.data);
                    if (response.data.data.user.role == 'doctor') {
                        commit('SET_ACTIVE_DOCTOR', response.data.data.user);
                    }
                    resolve(response);

                })
                .catch(function(error) {
                    console.log(error);
                    reject(error);
                });
        });

    },
    getFormattedDate(date) {
        var year = date.getFullYear();

        var month = (1 + date.getMonth()).toString();
        month = month.length > 1 ? month : '0' + month;

        var day = date.getDate().toString();
        day = day.length > 1 ? day : '0' + day;

        return month + '-' + day + '-' + year;
    },
    buildSchedule({ dispatch, commit, rootState }, payload) {
        //console.log(rootState.events);
        //console.log('payload: ', payload);

        var dateEvents = [];
        var dateTimes = [];
        let timeTable = globalTimeTable;
        if (rootState.events.length > 0) {
            rootState.events.forEach((element, index, array) => {
                // console.log(element.date);
                // '2021-01-07T14:00:00.000Z'
                let formatted = element.date.substring(5, 10) + '-' + element.date.substring(0, 4);
                if (payload.date == formatted) {
                    let tempDate = new Date(element.date);

                    let tempElement = new Object();
                    tempElement.date = element.date;
                    tempElement.formatted = formatted;
                    tempElement.time = `${("0"+tempDate.getHours()).slice(-2)}:${("0"+tempDate.getMinutes()).slice(-2)}`;
                    tempElement.event_id = element.id;
                    tempElement.event_title = element.title;
                    dateEvents.push(tempElement);
                    dateTimes.push(tempElement.time);
                }
                if (index == array.length - 1) {
                    // console.log(dateEvents);
                    // console.log(dateTimes);
                    return new Promise((resolve, reject) => {
                        // fixed time for now....
                        // timeTable = ['08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00'];
                        if (payload.schedule && payload.schedule.switch) {
                            const { startTime, endTime } = payload.schedule ? getValidHours(payload.schedule.time, payload.schedule.time2, payload.date) : {};
                            if (startTime && endTime) {
                                timeTable = createTimeTable(startTime, endTime);
                            }
                        } else {
                            timeTable = [];
                        }

                        var availableTimes = timeTable.filter(function(item, index) {
                            return !dateTimes.includes(item);
                        });
                        commit('SET_SCHEDULE', availableTimes);
                        //console.log('schedule: ',availableTimes);
                        resolve(availableTimes);
                    });
                }
            });
        } else {
            return new Promise((resolve, reject) => {
                commit('SET_SCHEDULE', timeTable);
                resolve(timeTable);
            });
        }
    },
    fetchClinicSchedule({ dispatch, commit, rootState }, payload) {
        var fetchURL;
        if (rootState.AppActiveUser.role == "doctor") {
            fetchURL = managementApiUrl + `events/schedule/clinic/${payload.clinic_id}?start_date=${payload.start_date}&end_date=${payload.end_date}&perPage=200&eventLength=${payload.eventLength}&requestDate=${payload.requestDate}&doctor_id=${rootState.AppActiveUser.id}`;
        } else {
            fetchURL = managementApiUrl + `events/schedule/clinic/${payload.clinic_id}?start_date=${payload.start_date}&end_date=${payload.end_date}&perPage=200&eventLength=${payload.eventLength}&requestDate=${payload.requestDate}&doctor_id=${sessionStorage.getItem('activeDoctorId')}`;
        }
        return new Promise((resolve, reject) => {
            var config = {
                method: 'get',
                url: fetchURL,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + rootState.AuthToken
                },
                // data: payload
            };
            axios(config)
                .then(function(response) {
                    // console.log(rootState.AuthToken)
                    commit('SET_CLINICABD', response.data.clinicAvailability.availability);
                    resolve(response);

                })
                .catch(function(error) {
                    console.log(error);
                    reject(error);
                });
        });
    },
    editEvent({ dispatch, rootState }, payload) {
        return new Promise((resolve, reject) => {
            var config = {
                method: 'put',
                url: eventsApiUrl + '/' + payload.event_id,
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken
                },
                data: payload
            };
            axios(config)
                .then(function(response) {

                    //console.log(response.data);
                    dispatch('fetchEvents');
                    resolve(response);

                })
                .catch(function(error) {
                    console.log(error);
                    reject(error);
                });
        });
    },
    updateClinic({ dispatch, rootState }, payload) {
        return new Promise((resolve, reject) => {
            var config = {
                method: 'put',
                url: clinicsUrl + '/' + payload.id,
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken
                },
                data: payload
            }

            axios(config)
                .then(function(response) {

                    dispatch('fetchClinics');
                    resolve(response);

                })
                .catch(function(error) {
                    console.log(error);
                    reject(error);
                });
        });
    },
    editEventPublic({ dispatch, rootState }, payload) {

        return new Promise((resolve, reject) => {
            axios.post(cloudFunctionUrl, {})
                .then((response) => {
                    //console.log(response);
                    let adminToken = response.data.user.stsTokenManager.accessToken;

                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + adminToken
                    }
                    var config = {
                        method: 'put',
                        url: eventsApiUrl + '/' + payload.event_id,
                        headers: headers,
                        data: payload
                    };

                    axios(config)
                        .then(function(response) {
                            //console.log(response.data);
                            resolve(response);
                        })
                        .catch(function(error) {
                            console.log(error);
                            reject(error);
                        });

                })
                .catch((error) => { reject(error) });

        });
    },
    deleteEvent({ dispatch, rootState }, payload) {
        return new Promise((resolve, reject) => {
            var config = {
                method: 'delete',
                url: eventsApiUrl + '/' + payload,
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken
                }
            };
            axios(config)
                .then(function(response) {

                    //console.log(response.data);
                    dispatch('fetchEvents');
                    resolve(response);

                })
                .catch(function(error) {
                    console.log(error);
                    reject(error);
                });
        });
    },
    // -------------------------
    // PRESCRIPTIONS
    // -------------------------
    addPrescription({ dispatch, rootState }, payload) {
        return new Promise((resolve, reject) => {
            var config = {
                method: 'post',
                url: managementApiUrl + 'prescriptions',
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken
                },
                data: payload
            };
            axios(config)
                .then(function(response) {

                    //console.log(response.data);
                    resolve(response);

                })
                .catch(function(error) {
                    console.log(error);
                    reject(error);
                });
        });
    },
    editPrescription({ dispatch, rootState }, payload) {
        return new Promise((resolve, reject) => {
            var config = {
                method: 'put',
                url: managementApiUrl + 'prescriptions/' + payload.prescription_id,
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken
                },
                data: payload
            };
            axios(config)
                .then(function(response) {

                    //console.log(response.data);
                    dispatch('fetchEvents');
                    resolve(response);

                })
                .catch(function(error) {
                    console.log(error);
                    reject(error);
                });
        });
    },
    getPrescriptionById({ commit, rootState }, id) {
        return new Promise((resolve, reject) => {
            var config = {
                method: 'get',
                url: managementApiUrl + 'prescriptions/' + id,
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken
                }
            };

            axios(config)
                .then(function(response) {
                    //console.log(response.data);
                    commit('SET_ACTIVE_PRESCRIPTION', response.data.data.prescription);
                    resolve(response);

                })
                .catch(function(error) {
                    console.log(error);
                    reject(error);
                });
        });
    },
    getPrescriptionByIdPublic({ commit, rootState }, id) {

        return new Promise((resolve, reject) => {
            axios.post(cloudFunctionUrl, {})
                .then((response) => {
                    //console.log(response);
                    let adminToken = response.data.user.stsTokenManager.accessToken;

                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + adminToken
                    }
                    var config = {
                        method: 'get',
                        url: managementApiUrl + 'prescriptions/' + id,
                        headers: headers,
                    };

                    axios(config)
                        .then(function(response) {
                            //console.log(response.data);
                            commit('SET_ACTIVE_PRESCRIPTION', response.data.data.prescription);
                            resolve(response);

                        })
                        .catch(function(error) {
                            console.log(error);
                            reject(error);
                        });
                });

        });
    },
    getPrescriptionsList({ commit, rootState }, ) {
        var fetchPrID;
        if (rootState.AppActiveUser.role == "doctor") {
            fetchPrID = rootState.AppActiveUser.id;
        } else {
            fetchPrID = sessionStorage.getItem('activeDoctorId');
        }

        return new Promise((resolve, reject) => {
            var config = {
                method: 'get',
                url: managementApiUrl + 'prescriptions/?perPage=300&currentPage=0',
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken
                }
            };

            axios(config)
                .then(function(response) {

                    //console.log(response.data);
                    var prescriptions = response.data.data.prescriptions.filter(obj => {
                        return obj.created_by_id == fetchPrID;
                    });
                    console.log(prescriptions)
                    // console.log(response.length)
                    commit('SET_PRESCRIPTIONS_LIST', prescriptions);
                    resolve(prescriptions);

                })
                .catch(function(error) {
                    console.log(error);
                    reject(error);
                });
        });
    },
    // -------------------------
    // EXAM
    // -------------------------
    addExam({ dispatch, rootState }, payload) {
        return new Promise((resolve, reject) => {
            var config = {
                method: 'post',
                url: managementApiUrl + 'exams',
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken
                },
                data: payload
            };
            axios(config)
                .then(function(response) {

                    //console.log(response.data);
                    resolve(response);

                })
                .catch(function(error) {
                    console.log(error);
                    reject(error);
                });
        });
    },
    editExam({ dispatch, rootState }, payload) {
        return new Promise((resolve, reject) => {
            var config = {
                method: 'put',
                url: managementApiUrl + 'exams/' + payload.exam_id,
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken
                },
                data: payload
            };
            axios(config)
                .then(function(response) {

                    //console.log(response.data);
                    dispatch('fetchEvents');
                    resolve(response);

                })
                .catch(function(error) {
                    console.log(error);
                    reject(error);
                });
        });
    },
    getExamById({ commit, rootState }, id) {
        return new Promise((resolve, reject) => {
            var config = {
                method: 'get',
                url: managementApiUrl + 'exams/' + id,
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken
                }
            };

            axios(config)
                .then(function(response) {
                    //console.log(response.data);
                    commit('SET_ACTIVE_EXAM', response.data.data.exam);
                    resolve(response);

                })
                .catch(function(error) {
                    console.log(error);
                    reject(error);
                });
        });
    },
    getExamByIdPublic({ commit, rootState }, id) {

        return new Promise((resolve, reject) => {
            axios.post(cloudFunctionUrl, {})
                .then((response) => {
                    //console.log(response);
                    let adminToken = response.data.user.stsTokenManager.accessToken;

                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + adminToken
                    }
                    var config = {
                        method: 'get',
                        url: managementApiUrl + 'exams/' + id,
                        headers: headers,
                    };

                    axios(config)
                        .then(function(response) {
                            //console.log(response.data);
                            commit('SET_ACTIVE_EXAM', response.data.data.exam);
                            resolve(response);

                        })
                        .catch(function(error) {
                            console.log(error);
                            reject(error);
                        });
                });

        });
    },
    getExamsList({ commit, rootState }, ) {
        var fetchExID;
        if (rootState.AppActiveUser.role == "doctor") {
            fetchExID = rootState.AppActiveUser.id;
        } else {
            fetchExID = sessionStorage.getItem('activeDoctorId');
        }
        return new Promise((resolve, reject) => {
            var config = {
                method: 'get',
                url: managementApiUrl + 'exams/?perPage=80&currentPage=1',
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken
                }
            };

            axios(config)
                .then(function(response) {
                    //console.log(response.data);
                    var exams = response.data.data.exams.filter(obj => {
                        return obj.created_by_id == fetchExID;
                    });
                    commit('SET_EXAMS_LIST', exams);
                    resolve(exams);

                })
                .catch(function(error) {
                    console.log(error);
                    reject(error);
                });
        });
    },
    // -------------------------
    // CLINICS
    // -------------------------
    addClinic({ dispatch, rootState }, payload) {
        return new Promise((resolve, reject) => {
            var config = {
                method: 'post',
                url: managementApiUrl + 'clinics',
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken
                },
                data: payload
            };
            axios(config)
                .then(function(response) {

                    //console.log(response.data);
                    dispatch('fetchClinics');
                    resolve(response);

                })
                .catch(function(error) {
                    console.log(error);
                    reject(error);
                });
        });
    },
    fetchClinics({ commit, rootState }) {
        var fetchClinicsID;

        if (rootState.AppActiveUser.role == "doctor") {
            fetchClinicsID = rootState.AppActiveUser.id;
        } else {
            fetchClinicsID = sessionStorage.getItem('activeDoctorId');
        }

        return new Promise((resolve, reject) => {
            var config = {
                method: 'get',
                url: managementApiUrl + 'clinics/?perPage=25&currentPage=1',
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken
                }
            };

            axios(config)
                .then(function(response) {

                    var myClinics = response.data.data.clinics.filter(obj => {
                        return obj.created_by_id == fetchClinicsID;
                    });
                    //console.log(response.data);
                    commit('SET_CLINICS', myClinics);
                    resolve(response);
                })
                .catch(function(error) {
                    console.log(error);
                });

        });
    },
    fetchClinicsPublic({ commit, rootState }, doctor_id) {
        axios.post(cloudFunctionUrl, {})
            .then((response) => {
                //console.log(response);
                let adminToken = response.data.user.stsTokenManager.accessToken;

                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + adminToken
                }
                var config = {
                    method: 'get',
                    url: managementApiUrl + 'clinics/?perPage=50&currentPage=1',
                    headers: headers
                };
                axios(config)
                    .then(function(response) {
                        var myClinics = response.data.data.clinics.filter(obj => {
                            return obj.created_by_id == doctor_id;
                        });
                        //console.log(response.data);
                        commit('SET_CLINICS_PUBLIC', myClinics);
                        commit('SET_CLINICS', myClinics);


                    })
                    .catch(function(error) {
                        console.log(error);
                    });

            })
            .catch((error) => { reject(error) });

    },
    fetchClinicSchedulePublic({ commit, rootState }, payload) {
        var fetchEventsURL = eventsApiUrl + '/?perPage=200&currentPage=1&doctor_id=' + payload.doctor_id;
        var fetchURL;
        if (rootState.AppActiveUser.role == "doctor") {
            fetchURL = managementApiUrl + `events/schedule/clinic/${payload.clinic_id}?start_date=${payload.start_date}&end_date=${payload.end_date}&perPage=200&eventLength=${payload.eventLength}&requestDate=${payload.requestDate}&doctor_id=${payload.doctor_id}`;
        } else {
            fetchURL = managementApiUrl + `events/schedule/clinic/${payload.clinic_id}?start_date=${payload.start_date}&end_date=${payload.end_date}&perPage=200&eventLength=${payload.eventLength}&requestDate=${payload.requestDate}&doctor_id=${payload.doctor_id}`;
        }
        return new Promise((resolve, reject) => {

            axios.post(cloudFunctionUrl, {})
                .then((response) => {
                    //console.log(response);
                    let adminToken = response.data.user.stsTokenManager.accessToken;

                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + adminToken
                    }
                    console.log(fetchURL)
                    var config = {
                        method: 'get',
                        url: fetchURL,
                        headers: headers,
                        // data: payload
                    };
                    axios(config)
                        .then(function(response) {
                            console.log(response)
                            commit('SET_CLINICABD', response.data.clinicAvailability.availability);
                            resolve(response);

                        })
                        .catch(function(error) {
                            console.log(error);
                            reject(error);
                        });


                })
                .catch((error) => { reject(error) });
            // --

        });
    },
    validateCitaMed(){
        return new Promise((resolve, reject) => {
            this.$validator.validateAll('cita-med').then(result => {
                if (result) {
                    this.getDateTimeTxt();
                    this.scroll();
                    resolve(true);
                } else {
                    reject('correct all values')
                }
            })
        });
    },
    editClinic({ commit }, payload) {

    },
    // -------------------------------
    // USER MANAGEMENT - PATIENTS ----
    // -------------------------------
    fetchAllUsers({ commit, rootState }) {
        return new Promise((resolve, reject) => {
            var config = {
                method: 'get',
                url: usersApiUrl + '/?perPage=1000&currentPage=1',
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken
                }
            };

            axios(config)
                .then(function(response) {

                    //console.log(response.data);
                    resolve(response);
                })
                .catch(function(error) {
                    console.log(error);

                });
        });
    },
    fetchPatients({ commit, rootState }) {
        var fetchURL;
        if (rootState.AppActiveUser.role == "doctor") {
            fetchURL = usersApiUrl + 'linked/patients?perPage=400&currentPage=1&doctor_id=' + rootState.AppActiveUser.id;
        } else {
            fetchURL = usersApiUrl + 'linked/patients?perPage=400&currentPage=1&doctor_id=' + sessionStorage.getItem('activeDoctorId');
        }

        return new Promise((resolve, reject) => {
            var config = {
                method: 'get',
                url: fetchURL,
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken
                }
            };

            axios(config)
                .then(function(response) {

                    //console.log(response.data);
                    var active_patients = response.data.data.users.filter(obj => {
                        return obj.active == true
                    });
                    // filtrar users where role = patient
                    commit('SET_ACTIVE_PATIENTS_COUNT', active_patients.length);
                    commit('SET_PATIENTS', response.data.data.users);
                    resolve(response);
                })
                .catch(function(error) {
                    console.log(error);

                });
        });
    },
    fetchPatient({ commit, rootState }, patientId) {
        return new Promise((resolve, reject) => {
            var config = {
                method: 'get',
                url: usersApiUrl + '/' + patientId,
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken
                }
            };

            axios(config)
                .then(function(response) {
                    //console.log(response.data);
                    // filtrar users where role = patient
                    commit('SET_CURRENT_PATIENT', response.data.data.user);
                    resolve(response);
                })
                .catch(function(error) {
                    console.log(error);

                });
        });
    },
    addPatientPublic({ dispatch }, payload) {
        return new Promise((resolve, reject) => {
            axios.post(cloudFunctionUrl, {})
                .then((response) => {
                    console.log(payload)
                    var doctor_id = payload.doctor_id
                    delete payload.doctor_id
                    console.log(payload)
                    var adminToken = response.data.user.stsTokenManager.accessToken;

                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + adminToken
                    }
                    // addPatient
                    var config = {
                        method: 'post',
                        url: usersApiUrl,
                        headers: headers,
                        data: payload
                    };
                    axios(config)
                        .then(function(response) {
                            dispatch('linkUserPublic', { doctor_id: doctor_id, email: response.data.data.user.email }).then(function(response2){
                                resolve(response);
                            }).catch(function(error2){
                                console.log(error2);
                                reject(error2);
                            });
                            
                        })
                        .catch(function(error) {
                            console.log(error);
                            reject(error);
                        });
                    // addPatient - end

                })
                .catch((error) => { reject(error) });
        })
    },
    addPatient({ dispatch, rootState }, payload) {

        return new Promise((resolve, reject) => {
            var config = {
                method: 'post',
                url: usersApiUrl,
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken,
                    "Access-Control-Allow-Origin": "*",
                    'Content-Type': 'application/json',
                },
                data: payload
            };
            axios(config)
                .then(function(response) {
                    //console.log(response.data);
                    var emptyObj = new Object();
                    // aca debe ir el doctor_id si es secretaria 
                    // emptyObj.doctor_id = rootState.AppActiveUser.id;
                    // emptyObj.email = response.data.data.user.email;
                    if (rootState.AppActiveUser.role == "doctor") {
                        dispatch('linkUser', { doctor_id: rootState.AppActiveUser.id, email: response.data.data.user.email });
                    } else {
                        dispatch('linkUser', { doctor_id: sessionStorage.getItem('activeDoctorId'), email: response.data.data.user.email });
                    }

                    resolve(response);
                })
                .catch(function(error) {
                    console.log(error);
                    reject(error);
                });
        });
    },
    generateReceipt({ dispatch, rootState }, payload) {

        return new Promise((resolve, reject) => {
            var config = {
                method: 'post',
                url: factUrl,
                headers: {
                    'Content-Type': 'application/json',
                },
                data: payload
            };
            axios(config)
                .then(function(response) {
                    //console.log(response.data);
                    var emptyObj = new Object();
                    // aca debe ir el doctor_id si es secretaria 
                    // emptyObj.doctor_id = rootState.AppActiveUser.id;
                    // emptyObj.email = response.data.data.user.email;
                    console.log(response)

                    resolve(response);
                })
                .catch(function(error) {
                    console.log(error);
                    reject(error);
                });
        });
    },
    validateNit({ dispatch, rootState }, payload) {
        console.log(payload)
        return new Promise((resolve, reject) => {
            var config = {
                method: 'get',
                url: nitUrl + payload,
                headers: {
                    'Content-Type' : 'application/json',
                },
                data: payload
            };
            axios(config)
                .then(function(response) {
                    //console.log(response.data);

                    console.log(response)

                    resolve(response);
                })
                .catch(function(error) {
                    console.log(error);
                    reject(error);
                });
        });
    },
    generateAnul({ dispatch, rootState }, payload) {
        return new Promise((resolve, reject) => {
            var config = {
                method: 'post',
                url: anulUrl,
                data: payload
            };
            axios(config)
                .then(function(response) {
                    //console.log(response.data);
                    var emptyObj = new Object();
                    // aca debe ir el doctor_id si es secretaria 
                    // emptyObj.doctor_id = rootState.AppActiveUser.id;
                    // emptyObj.email = response.data.data.user.email;
                    console.log(response)

                    resolve(response);
                })
                .catch(function(error) {
                    console.log(error);
                    reject(error);
                });
        });
    },
    // -------------------------------
    // USER MANAGEMENT - SECRETARIES -
    // -------------------------------
    // -------------------------------
    // USER MANAGEMENT - GENERAL -----
    // -------------------------------
    linkUser({ dispatch, rootState }, payload) {
        return new Promise((resolve, reject) => {
            var config = {
                method: 'post',
                url: usersApiUrl + 'link',
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken
                },
                data: payload
            };
            axios(config)
                .then(function(response) {

                    //console.log(response.data);
                    dispatch('fetchPatients');
                    resolve(response);

                })
                .catch(function(error) {
                    reject(error);
                });
        });
    },
    linkUserPublic({ dispatch, rootState }, payload) {
        return new Promise((resolve, reject) => {
            axios.post(cloudFunctionUrl, {})
                .then((response) => {
                    //console.log(response);
                    let adminToken = response.data.user.stsTokenManager.accessToken;

                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + adminToken
                    }

                    var config = {
                        method: 'post',
                        url: usersApiUrl + 'link',
                        headers: headers,
                        data: payload
                    };
                    axios(config)
                        .then(function(response) {

                            //console.log(response.data);
                            resolve(response);

                        })
                        .catch(function(error) {
                            reject(error);
                        });

                })
                .catch((error) => { reject(error) });

        });


    },
    editUser({ dispatch, rootState }, payload) {
        return new Promise((resolve, reject) => {
            var config = {
                method: 'put',
                url: usersApiUrl + payload.id,
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken
                },
                data: payload
            };
            axios(config)
                .then(function(response) {
                    //console.log(response.data);
                    resolve(response);
                })
                .catch(function(error) {
                    console.log(error);
                    reject(error);
                });
            if (payload.active) {
                var config2 = {
                    method: 'post',
                    url: usersApiUrl + payload.id + '/reactivate',
                    headers: {
                        'Authorization': 'Bearer ' + rootState.AuthToken
                    },
                };
                axios(config2)
                    .then(function(response) {
                        //console.log(response.data);
                        resolve(response);
                    })
                    .catch(function(error) {
                        console.log(error);
                        reject(error);
                    });
            }
        });
    },
    editUserPublic({ dispatch, rootState }, payload) {

        return new Promise((resolve, reject) => {
            axios.post(cloudFunctionUrl, {})
                .then((response) => {
                    //console.log(response);
                    let adminToken = response.data.user.stsTokenManager.accessToken;

                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + adminToken
                    }

                    var config = {
                        method: 'put',
                        url: usersApiUrl + payload.id,
                        headers: headers,
                        data: payload
                    };

                    axios(config)
                        .then(function(response) {
                            //console.log(response.data);
                            resolve(response);
                        })
                        .catch(function(error) {
                            console.log(error);
                            reject(error);
                        });

                    if (payload.active) {
                        var config2 = {
                            method: 'post',
                            url: usersApiUrl + payload.id + '/reactivate',
                            headers: headers,
                        };
                        axios(config2)
                            .then(function(response) {
                                //console.log(response.data);
                                resolve(response);
                            })
                            .catch(function(error) {
                                console.log(error);
                                reject(error);
                            });
                    }

                })
                .catch((error) => { reject(error) });

        });
    },
    removeSecretary({ dispatch, rootState }, payload) {
        return new Promise((resolve, reject) => {
            axios.post(cloudFunctionUrl, {})
                .then((response) => {
                    //console.log(response);
                    let adminToken = response.data.user.stsTokenManager.accessToken;

                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + adminToken
                    }

                    var config = {
                        method: 'delete',
                        url: usersApiUrl + payload.id,
                        headers: headers,
                        data: payload
                    };

                    axios(config)
                        .then(function(response) {
                            //console.log(response.data);
                            dispatch('fetchSecretaries');
                            resolve(response);
                        })
                        .catch(function(error) {
                            console.log(error);
                            reject(error);
                        });
                })
                .catch((error) => { reject(error) });

        });
    },
    removeClinic({ dispatch, rootState }, payload) {
        return new Promise((resolve, reject) => {
            axios.post(cloudFunctionUrl, {})
                .then((response) => {
                    //console.log(response);
                    let adminToken = response.data.user.stsTokenManager.accessToken;

                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + adminToken
                    }

                    var config = {
                        method: 'delete',
                        url: clinicsUrl + '/' + payload,
                        headers: headers,
                        data: payload
                    };

                    axios(config)
                        .then(function(response) {
                            //console.log(response.data);
                            dispatch('fetchClinics');
                            resolve(response);
                        })
                        .catch(function(error) {
                            console.log(error);
                            reject(error);
                        });
                })
                .catch((error) => { reject(error) });

        });
    },
    removePatient({ dispatch, rootState }, payload) {
        return new Promise((resolve, reject) => {
            axios.post(cloudFunctionUrl, {})
                .then((response) => {
                    //console.log(response);
                    let adminToken = response.data.user.stsTokenManager.accessToken;

                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + adminToken
                    }

                    var config = {
                        method: 'delete',
                        url: usersApiUrl + '/' + payload,
                        headers: headers,
                    };

                    axios(config)
                        .then(function(response) {
                            //console.log(response.data);
                            dispatch('fetchClinics');
                            resolve(response);
                        })
                        .catch(function(error) {
                            console.log(error);
                            reject(error);
                        });
                })
                .catch((error) => { reject(error) });

        });
    },
    fetchSecretaries({ commit, rootState }) {
        return new Promise((resolve, reject) => {
            var config = {
                method: 'get',
                url: usersApiUrl + 'linked/secretaries?perPage=70&currentPage=1&doctor_id=' + rootState.AppActiveUser.id,
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken
                }
            };

            axios(config)
                .then(function(response) {

                    //console.log(response.data);
                    let data = [];
                    if (response.data.data.users) {
                        data = response.data.data.users.filter(secretary => secretary.active);
                    }
                    var config2 = {
                        method: 'get',
                        url: usersApiUrl + 'linked/enfermeras?perPage=70&currentPage=1&doctor_id=' + rootState.AppActiveUser.id,
                        headers: {
                            'Authorization': 'Bearer ' + rootState.AuthToken
                        }
                    }
                    axios(config2)
                    .then(function(response2) {

                        //console.log(response.data);
                        let data2 = [];
                        if (response2.data.data.users) {
                            data2 = response2.data.data.users.filter(enfermera => enfermera.active);
                        }
                        console.log([ ...data, ...data2])
                        commit('SET_SECRETARIES', [ ...data, ...data2]);
                        resolve(response2);
                    })
                    .catch(function(error) {
                        console.log(error);
    
                    });
                    resolve(response);
                
                })
                .catch(function(error) {
                    console.log(error);

                });
        });
    },
    // ----------------
    // MEDICATIONS ----
    // ----------------
    fetchMedications({ commit, rootState }) {
        var config = {
            method: 'get',
            url: managementApiUrl + '/medications/?perPage=16000&currentPage=1',
            headers: {
                'Authorization': 'Bearer ' + rootState.AuthToken
            }
        };

        axios(config)
            .then(function(response) {

                //console.log(response.data);

                // setting medications
                commit('SET_MEDICATIONS', response.data.data.medications);

            })
            .catch(function(error) {
                console.log(error);

            });
    },
    // ----------------
    // NOTIFICATIONS
    // ----------------
    sendNotification({ dispatch, rootState }, payload) {

        //console.log('NOTIFY', payload)
        var axios = require('axios');

        var config = {
            method: 'post',
            url: notificationsUrl,
            headers: {
                'Authorization': 'Bearer ' + rootState.AuthToken,
                'Content-Type': 'application/json',
            },
            data: payload
        };

        axios(config)
            .then(function(response) {
                //console.log('notify success');
                //console.log(response.data);
            })
            .catch(function(error) {
                console.log(config, payload)
                console.log('notify ERROR');
                console.log(error);
            });
    },
    readNotification({ dispatch, rootState }, id) {
        //console.log('Mark as read', id)
        var axios = require('axios');

        var config = {
            method: 'post',
            url: notificationsUrl + '/' + id + '/read',
            headers: {
                'Authorization': 'Bearer ' + rootState.AuthToken,
                'Content-Type': 'application/json',
            },
        };

        axios(config)
            .then(function(response) {
                //console.log('read notification success');
                //console.log(response.data);
                dispatch('fetchNotifs', rootState.AppActiveUser.email);
            })
            .catch(function(error) {
                console.log('notify ERROR');
                console.log(error);
            });
    },
    sendNotificationPublic({ dispatch }, payload) {

        //console.log('PUBLIC NOTIFICATION', payload);

        return new Promise((resolve, reject) => {
            axios.post(cloudFunctionUrl, {})
                .then((response) => {
                    //console.log(response);
                    var adminToken = response.data.user.stsTokenManager.accessToken;

                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + adminToken
                    }

                    var config = {
                        method: 'post',
                        url: notificationsUrl,
                        headers: headers,
                        data: payload
                    };
                    axios(config)
                        .then(function(response) {
                            //console.log('notify success');
                            //console.log(response.data);
                            resolve(response);
                        })
                        .catch(function(error) {
                            console.log('notify ERROR');
                            console.log(error);
                        });

                })
                .catch((error) => { reject(error) });
        })
    },
    sendNotification2({ dispatch, rootState }, payload) {
        var config = {
            method: 'post',
            url: notificationsUrl,
            headers: {
                'Authorization': 'Bearer ' + rootState.AuthToken,
                "Access-Control-Allow-Origin": "*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': true,
                'crossorigin': true
            },
            data: payload
        };
        //console.log('NOTIFICATION');
        axios(config)
            .then(function(response) {
                //console.log(response.data);
            }).catch(function(error) {
                console.log(error);
            });
    },
    // ------------------------------------------------
    // -------------NOTIFICATIONS-LOG------------------
    // ------------------------------------------------
    fetchNotifs({ commit, rootState }, email) {

        return new Promise((resolve, reject) => {
            var config = {
                method: 'get',
                url: notificationsUrl + '?perPage=500&currentPage=1',
                headers: {
                    'Authorization': 'Bearer ' + rootState.AuthToken
                }
            };

            axios(config)
                .then(function(response) {

                    //console.log('NOTIFICACIONES:',response.data);
                    commit('SET_NOTIFS_LIST', response.data.data.notifications);
                    resolve(response);
                })
                .catch(function(error) {
                    console.log(error);
                });

        });
    },
}

export default actions